import { render, staticRenderFns } from "./to-delete.vue?vue&type=template&id=69affa99&scoped=true"
import script from "./to-delete.vue?vue&type=script&lang=js"
export * from "./to-delete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69affa99",
  null
  
)

export default component.exports